import classNames from "classnames";
import { useCollapsibleViewContext } from "./CollapsibleViewContext";

type CollapsibleViewButtonLabels = {
    collapseLabel: string;
    showLabel: string;
};
interface CollapsibleViewButtonProps {
    labels: CollapsibleViewButtonLabels;
}

export const CollapsibleViewButton = ({ labels }: CollapsibleViewButtonProps) => {
    const { isCollapsed, setCollapsibleView } = useCollapsibleViewContext();

    return (
        <button
            type="button"
            className={classNames("link iconAfter", {
                iconArrowSmallDownAfter: isCollapsed,
                iconArrowSmallUpAfter: !isCollapsed,
            })}
            onClick={() => {
                setCollapsibleView(!isCollapsed);
            }}
        >
            {isCollapsed ? labels.showLabel : labels.collapseLabel}
        </button>
    );
};
